export function getThumbnailUrl(NEXT_PUBLIC_PROXY, documentId) {
  const proxy = NEXT_PUBLIC_PROXY;
  if (!documentId.toString().startsWith('referentiedetail')) {
    return 'https://quest5.isso.nl/api/document/cover/' + documentId;
  } else {
    return proxy + '/document/reference_detail/cover/' + documentId;
  }
}
